import React, { Component } from "react";
import { connect } from "react-redux";
import { withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { Button } from "antd";

import { toggleConfirmationModal } from "../confirmationModal/confirmationModalActions";
import { getLenderId, getRole } from "../../common/helpers";
import HeaderWithArrow from "../../components/headerWithArrow/headerWithArrow";
import { modalPopupStates } from "../../common/constants";

import "./fundingLimit.less";
import { FUNDING_CYCLE_STEPS } from "./constants";
import DynamicStepComponent from "./dynamicStepComponent";
@connect(
  ({ localize, confirmation: { showingConfirmationModal, action } }) => ({
    translate: getTranslate(localize),
    showingConfirmationModal,
    action,
  })
)
@withActions({
  toggleConfirmationModal,
})
class SetupFundingCycle extends Component {
  constructor() {
    super();
    this.state = {
      currentStep: FUNDING_CYCLE_STEPS[0].key,
      currentLenderId: null,
      role: "",
    };
    this.setCurrentLender = this.setCurrentLender.bind(this);
    this.nextStepClicked = this.nextStepClicked.bind(this);
    this.prevStepClicked = this.prevStepClicked.bind(this);
    this.confirmAllocationClicked = this.confirmAllocationClicked.bind(this);
  }

  async componentWillMount() {
    //API call to get list of all products
    const role = await getRole(),
      lenderId = await getLenderId();
    this.setState({ currentLenderId: lenderId, role });
  }

  setCurrentLender(lenderId) {
    this.setState({ currentLenderId: lenderId });
  }

  nextStepClicked = () => {
    if (this.state.currentStep === FUNDING_CYCLE_STEPS.length) {
      //do nothing
    } else {
      this.setState((prevState) => ({
        currentStep: prevState.currentStep + 1,
      }));
    }
  };

  prevStepClicked = () => {
    if (this.state.currentStep === 1) {
      //do nothing
    } else {
      this.setState((prevState) => ({
        currentStep: prevState.currentStep - 1,
      }));
    }
  };

  confirmAllocationClicked() {
    //validations
    this.props.toggleConfirmationModal(modalPopupStates.confirmAllocation);
  }

  renderStepTimeline = () => {
    const { translate } = this.props,
      { currentStep } = this.state;
    return FUNDING_CYCLE_STEPS.map((stepConfig, index) => {
      const stepClass =
          stepConfig.key <= currentStep ? "step-complete" : "step-incomplete",
        stepLine =
          stepConfig.key + 1 <= currentStep
            ? "step-complete"
            : "step-incomplete";
      return (
        <div className="step-inline-container" key={stepConfig.key - 1}>
          <div className="step-text-container">
            <div className={`step-head ${stepClass}`}></div>
            <div>{translate(`fundingLimit.${stepConfig.nameKey}`)}</div>
          </div>
          {!stepConfig.isLastStep ? (
            <div className={`step-tail ${stepLine}`}></div>
          ) : (
            <></>
          )}
        </div>
      );
    });
  };

  renderHeaderTitle = (stepConfig) => {
    const { translate } = this.props;
    return (
      <HeaderWithArrow
        title={translate(`fundingLimit.${stepConfig.componentTitleKey}`)}
        showArrow={!stepConfig.isFirstStep}
        arrowClicked={this.prevStepClicked}
      />
    );
  };

  renderButtonForNavigation = (stepConfig) => {
    const { translate } = this.props,
      onClickNext = !stepConfig.isLastStep
        ? this.nextStepClicked
        : this.confirmAllocationClicked;
    return (
      <>
        {this.state.currentStep !== 1 ? (
          <Button type="secondary" onClick={this.prevStepClicked}>
            {translate("fundingLimit.back")}
          </Button>
        ) : (
          <></>
        )}
        <Button type="primary" onClick={onClickNext}>
          {!stepConfig.isLastStep
            ? translate("fundingLimit.button_next")
            : translate("fundingLimit.ovo_admin_button_confirm_allocation")}
        </Button>
      </>
    );
  };

  renderAppropriateStepUI = () => {
    const { currentStep } = this.state,
      stepConfig = FUNDING_CYCLE_STEPS[currentStep - 1];

    const onClickNext = !stepConfig.isLastStep
      ? this.nextStepClicked
      : this.confirmAllocationClicked;

    return (
      <div className="individual-step-container" key={currentStep}>
        {this.renderHeaderTitle(stepConfig)}
        <DynamicStepComponent
          componentNameKey={stepConfig.componentNameKey}
          nextStepClicked={onClickNext}
          prevStepClicked={this.prevStepClicked}
        />
        {/* {this.renderButtonForNavigation(stepConfig)} */}
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="setup-funding-cycle-container">
          <div className="step-container">{this.renderStepTimeline()}</div>
          {this.renderAppropriateStepUI()}
        </div>
      </>
    );
  }
}

export default SetupFundingCycle;
